import type { Maybe, ProductColorData } from '~/utilities/graphql/codegen';

export type ColorDataAttributes = {
  'data-main-color-family'?: string;
  'data-main-color-hex'?: string;
  'data-main-color-sort-key'?: string;
};

/**
 * FS-4858: exposes the M07 image colour of a product for CRO A/B tests. Absent values
 * stay undefined so React omits the attribute instead of rendering an empty one.
 */
export const getColorDataAttributes = (
  colorData?: Maybe<ProductColorData>
): ColorDataAttributes => ({
  'data-main-color-family': colorData?.colorFamily || undefined,
  'data-main-color-hex': colorData?.mainColorHex || undefined,
  'data-main-color-sort-key': colorData?.colorSortKey || undefined,
});
